import { httpClient } from '../client';
import {
  StationData,
  BankQuotaResponse,
  StationOverviewResponse,
  getStationDetailResponse
} from './types';

export * from './types';

export class StationApi {
  async getList(eventID: string): Promise<StationData[]> {
    return httpClient.legacyGet<StationData[]>('/getStationList', { eventID });
  }

  async getDetail(stationID: string, eventID: string, decrypted: boolean): Promise<getStationDetailResponse> {
    return httpClient.get(`/flagbageasy/flagbagstation/${stationID}`, { eventId: eventID, decrypted: decrypted });
  }

  async getOverview(eventID: string): Promise<StationOverviewResponse> {
    return httpClient.get('/flagbageasy/flagbagvolunteer/managed-stations', { eventId: eventID, decrypted: true, });
  }

  async getGroups(stationID: string): Promise<any> {
    return httpClient.legacyGet('/getGroupList', { stationID });
  }

  async getBankQuota(eventID: string, stationID: string): Promise<BankQuotaResponse> {
    return httpClient.get<BankQuotaResponse>(
      '/flagbageasy/flagbagstation/station-bank-quota',
      {
        eventId: eventID,
        stationId: stationID
      }
    );
  }
}

export const stationApi = new StationApi();
